export default {
  refreshRequired: false,
  currentSn: '',
  domesticVoiceAverage12Months: { labels: [], series: [] },
  domesticVoiceTotal12Months: { labels: [], series: [] },
  domesticDataTotal12Months: { labels: [], series: [] },
  domesticDataAverage12Months: { labels: [], series: [] },
}
